import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { RoomApiService } from '@shared/services';
import { ROOM_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const roomEventFormConfig = (): FormConfig => {
  const roomApiService = inject(RoomApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'name', label: 'Tên sự kiện', required: true, width: 'full',
        type: 'text', placeholder: 'Nhập tên sự kiện'
      },
      {
        key: 'userId', label: 'User ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'roomId', label: 'Phòng', required: true, width: 'full',
        type: 'select', config: { ...ROOM_SELECT_CONFIG, service: roomApiService }
      },
      {
        key: 'fromDate', label: 'Thời gian bắt đầu', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn thời gian bắt đầu',
        datePickerMode: 'dateTime'
      },
      {
        key: 'toDate', label: 'Thời gian kết thúc', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn thời gian kết thúc',
        datePickerMode: 'dateTime'
      }
    ]
  };
};
